import * as React from "react";

function SvgIcons8Code(props, ref) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...{ ...props, ref }}>
      <path d="M4 5v22h24V5zm2 2h20v2H6zm0 4h20v14H6zm10 2l-2 10h2l2-10zm-4.813.406l-3 4L7.75 18l.438.594 3 4 1.624-1.188L10.25 18l2.563-3.406zm9.626 0l-1.625 1.188L21.75 18l-2.563 3.406 1.625 1.188 3-4L24.25 18l-.438-.594z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8Code);
